module.exports = __webpack_public_path__ + "static/sofa2-de92b32236768dee2905a2f13a8a0ceb.webp";